import theme from '../../../themes/green';

const styles = {
  wrapper: {
    padding: 10,
    borderBottom: `1px solid ${theme.pallete.lightBackground}`,
  },
  header: {
    height: 30,
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.pallete.background,
  },
  resetButton: {
    background: 'transparent',
    border: 0,
    fontSize: 13,
    cursor: 'pointer',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Inspector/InspectorSection/styles.js